import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

import { LoginContain, Background } from './Styled';
import Login from './Login';
import { withWidth } from 'components/useWithWidth';

import { login } from '../../actions/session';
import { errorClear } from 'actions/error';

const LoginContainer = ({
  isAuth,
  history,
  location,
  loading,
  errorMessage,
  dispatchLogin,
  dispatchErrorClear
}) => {
  useEffect(
    function clearErrors() {
      dispatchErrorClear();
    },
    [dispatchErrorClear]
  );

  const [state, setState] = useState({
    email: '',
    password: '',
    success: false
  });

  useEffect(() => {
    var route = (location.state && location.state.from) || '/orders';

    isAuth && history.replace(route);
  }, [history, isAuth, location]);

  const handleAuth = () => {
    dispatchErrorClear();
    dispatchLogin(state);
  };

  const handleResetClick = () => history.replace('/password-reset');

  const handleRegisterClick = () => history.replace('/register');

  const handleChange = (name, value) =>
    setState((values) => ({
      ...values,
      [name]: value
    }));

  const handleKeyPress = (e) => {
    const name = e.target.id;
    const password = document.getElementById('password');

    if (e.key === 'Enter') {
      switch (name) {
        case 'email':
          return password && password.focus();
        case 'password':
          return handleAuth();
        default:
          return null;
      }
    }
  };

  return (
    <Background>
      <LoginContain>
        <Login
          loading={loading}
          email={state.email}
          password={state.password}
          onChange={handleChange}
          handleAuth={handleAuth}
          onKeyPress={handleKeyPress}
          errorMessage={errorMessage}
          onRegister={handleRegisterClick}
          onResetPassword={handleResetClick}
        />
      </LoginContain>
    </Background>
  );
};

const mapDispatchToProps = {
  dispatchLogin: login,
  dispatchErrorClear: errorClear
};

const mapStateToProps = ({ error, loading, session }) => ({
  isAuth: session.isAuth,
  errorMessage: error.message,
  loading: loading.loadingSession
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withWidth(LoginContainer))
);
